/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {DbFactory} from '../../db/factory/dbFactory';
import {StorageRequest} from './storage-request';

export class StorageRequestFactory implements DbFactory<StorageRequest> {
  convertSerial(o: any): StorageRequest {
    return new StorageRequest(o.url, o.method, o.token, o.content, new Date(o.stamp));
  }

  getStorageName(): string {
    return 'inf-cache';
  }

  getIndexName(): string {
    return 'validity';
  }
}
